module.exports = __webpack_public_path__ + "static/img/Ace of Wands.8d71883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ace of Wands.jpg
// module id = 1259
// module chunks = 0